import type { CheckGroup } from "@shared/site-audit-report-view";
import { ReportSection } from "./section";

export function SiteChecks({ groups }: { groups: CheckGroup[] }) {
  if (groups.length === 0) return null;
  return (
    <ReportSection id="checks" title="Site checks" hint="A training-bot block is a choice, not a failure.">
      <div className="space-y-4">
        {groups.map((group) => (
          <div key={group.id}>
            <h3 className="text-sm font-semibold">{group.label}</h3>
            <ul className="mt-2 space-y-2">
              {group.rows.map((row) => (
                <li key={`${row.id}-${row.subject}`} className="text-sm">
                  <p>
                    <span className="font-medium">{row.subject}</span>
                    <span className={row.tone === "problem" ? " text-destructive" : " text-foreground/75"}>
                      {" "}
                      · {row.verdictLabel}
                    </span>
                  </p>
                  <p className="text-foreground/75">{row.detail}</p>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </ReportSection>
  );
}
